import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetServices } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetServicesFiltersState,
  fleetServicesHasAnyFilterState,
  fleetServicesReloadListState,
} from '../../../storage/fleetServices';

export function useFleetServices() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetServicesFiltersState);
  const [reload, setReload] = useRecoilState(fleetServicesReloadListState);
  const resetAllFilters = useResetRecoilState(fleetServicesFiltersState);
  const hasActiveFilters = useRecoilValue(fleetServicesHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      configurationId: undefined,
      status: undefined,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetServices = async () => {
    if (!apiParams)
      return {
        services: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { services, error, total } = await getFleetServices({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      configurationId: filters.configurationId,
      status: filters.status,
      search: filters.search,
    });
    return {
      services,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetServices,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
    filters: {
      configurationId: filters.configurationId,
      status: filters.status,
    },
    onChangeFilter: (filterName: 'configurationId' | 'status', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}
